import apiDashboard from "../../ApiDashboard";

const DEFAULT_MESSAGE = 'Não foi possível realizar essa ação por favor tente mais tarde.';
const URL = 'api/dinheirosim/user/logs';

export class LogsAuthServices {
    async list(params: any): Promise<any[]> {
        try {
            params.page = params.page || 1;
            params.cpf = params.cpf?.replace(/[^\w\s]/gi, '');

            const response = await apiDashboard.post(`${URL}/list`, params);

            return [response.data, undefined];
        } catch (e: any) {
            return [undefined, DEFAULT_MESSAGE];
        }
    }

    async export(params: any): Promise<any> {
        try {
            params.cpf = params.cpf?.replace(/[^\w\s]/gi, '');

            const response = await apiDashboard.post(`${URL}/export`, params);
            return [response?.data, undefined];
        } catch (e: any) {
            return [undefined, e.response?.data?.message || DEFAULT_MESSAGE];
        }
    }
}